import { useEffect, useState } from 'react';
import { Credit } from 'lib/types/credits';
import { CreditEdit } from 'components/CreditEdit';
import { EditableCreditItem } from './EditableCreditItem';

interface Props {
  credits: Credit[];
  postId: number;
  onChange: () => void;
  onEdit?: () => void;
}

export function CreditsTableView({
  credits, postId, onChange, onEdit,
}: Props) {
  const [editId, setEditId] = useState<number | undefined>();

  const startEdit = (creditId: number) => {
    setEditId(creditId);
    if (onEdit) onEdit();
  };

  useEffect(() => {
    // If the credits length or postId changes, reset the editId
    setEditId(undefined);
  }, [credits?.length, postId]);

  return (
    <ul>
      {
        credits.map((credit) => (
          <li key={credit.id}>
            {editId === credit.id
              ? (
                <CreditEdit
                  postId={postId}
                  credit={credit}
                  credits={credits}
                  onCancel={() => setEditId(undefined)}
                  onChange={onChange}
                />
              )
              : (
                <EditableCreditItem
                  credit={credit}
                  onStartEdit={() => startEdit(credit.id)}
                />
              )}
          </li>
        ))
      }
    </ul>
  );
}
